import type { DonationTypeEnumEnum } from '@/shared/api'
import { type PresetColorType } from 'antd/es/_util/colors'

export const DonationTypeEnum = {
  Donate: 1 as DonationTypeEnumEnum,
} as const

export type DonationTypeEnum =
  (typeof DonationTypeEnum)[keyof typeof DonationTypeEnum]

export const albumTypeArray = Object.values(DonationTypeEnum)

export const getDonationTypeString = (type: DonationTypeEnum) => {
  switch (type) {
    case DonationTypeEnum.Donate:
      return 'Пожертвование'
    default:
      return 'Неизвестный тип'
  }
}

export const getDonationTypeColor = (
  type: DonationTypeEnum,
): PresetColorType => {
  switch (type) {
    case DonationTypeEnum.Donate:
      return 'purple'
    default:
      return 'pink'
  }
}
